module.exports = __webpack_public_path__ + "img/BannerNoClientesDesktop.c97e934f.png";